import { Subject, filter, map, of, merge } from 'rxjs';
import * as i0 from '@angular/core';
import { Injectable, Optional } from '@angular/core';
import { concatMap, scan, shareReplay, map as map$1, filter as filter$1, distinctUntilChanged } from 'rxjs/operators';

class Actions {
    constructor() {
        this.action$$ = new Subject();
        this.action$ = this.action$$.asObservable();
    }
    dispatch(action, payLoad) {
        this.action$$.next({ action, payLoad });
    }
    on(action) {
        return this.action$.pipe(filter((actionObject) => actionObject.action === action), map((actionObject) => {
            return actionObject?.payLoad;
        }));
    }
}

/**
 * Base class for Effects and Reducers.
 */
class EffectOrReducer {
    constructor() {
        this.subscription = null;
    }
    init() {
        this.subscription = this.actionObservable$().subscribe();
    }
    ngOnDestroy() {
        this.subscription?.unsubscribe();
    }
}
EffectOrReducer.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: EffectOrReducer, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
EffectOrReducer.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: EffectOrReducer });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: EffectOrReducer, decorators: [{
            type: Injectable
        }] });

class EffectsAndReducersLoader {
    constructor(i) {
        this.i = i;
    }
    load() {
        this.services.forEach((t) => {
            this.i.get(t);
        });
    }
}

// @Injectable()
class StoreConfigService {
    constructor() {
        this.init = null;
    }
}

class StoreService {
    constructor(config) {
        this.stateSubject$ = new Subject();
        this.state$ = this.stateSubject$.pipe(concatMap((value) => {
            return of(value);
        }), scan((acc, newVal) => {
            return this.updateState(acc, newVal);
        }), shareReplay(1));
        // SUBSCRIPTIONS
        this.subscriptions = merge(this.state$).subscribe();
        if (config?.init) {
            this.init(config.init);
        }
    }
    updateState(acc, newVal) {
        return { ...acc, ...newVal };
    }
    init(object) {
        this.stateSubject$.next(object);
    }
    update(key, value) {
        deepFreeze(value);
        const newObject = {};
        newObject[key] = value;
        this.stateSubject$.next(newObject);
    }
    get$(key) {
        return this.state$.pipe(map$1((value) => value[key]), filter$1((value) => value !== undefined), map$1((value) => value), distinctUntilChanged((prev, curr) => {
            return prev === curr;
        }));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
}
StoreService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: StoreService, deps: [{ token: StoreConfigService, optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
StoreService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: StoreService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.1.3", ngImport: i0, type: StoreService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: StoreConfigService, decorators: [{
                    type: Optional
                }] }]; } });
function deepFreeze(o) {
    Object.freeze(o);
    if (o == null) {
        return o;
    }
    Object.getOwnPropertyNames(o).forEach(function (prop) {
        if (o.hasOwnProperty(prop) &&
            o[prop] !== null &&
            (typeof o[prop] === 'object' || typeof o[prop] === 'function') &&
            !Object.isFrozen(o[prop])) {
            deepFreeze(o[prop]);
        }
    });
    return o;
}

/*
 * Public API Surface of angular-simple-redux-lib
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Actions, EffectOrReducer, EffectsAndReducersLoader, StoreConfigService, StoreService };
//# sourceMappingURL=angular-simple-redux-lib.mjs.map
